import gql from 'graphql-tag';

export const PROFILE_PICTURE_MUTATION = gql`
  mutation UploadOrDeleteProfilePicture($file: Upload) {
    uploadOrDeleteProfilePicture(file: $file) {
      profilePictureUrl
      ok
    }
  }
`;

export const EVENT_PHOTO_MUTATION = gql`
  mutation uploadEventPhoto($file: Upload!, $isCoverPhoto: Boolean) {
    uploadEventPhoto(input: { file: $file, isCoverPhoto: $isCoverPhoto }) {
      photoUrl
      ok
    }
  }
`;

export const COMMUNITY_PHOTO_MUTATION = gql`
  mutation uploadCommunityPhoto($file: Upload!, $isCoverPhoto: Boolean) {
    uploadCommunityPhoto(input: { file: $file, isCoverPhoto: $isCoverPhoto }) {
      uploadCommunityPhotoUrl
      ok
    }
  }
`;
